import {AppSettingsActionType} from "../Constants/AppSettingsActionType";

export const setAppSettings = settings => {
	return {
		type: AppSettingsActionType.SET_SETTINGS,
		payload: settings,
	};
};
